import API from "@irati/utils/services/API"
import {Tenant, UnauthedBusiness} from "@irati/types"
import client, {QueryOptions} from "@irati/utils/services/apollo"
import PBService from "@irati/utils/services"
import {QueryBusinessArgs} from "@irati/types/ops"

import endpoints from "../endpoints"
import getTenantFromPathHelper from "../helpers/getTenantFromPath"
import tenantErrorHandler from "./errors/legacy/tenantErrorHandler"
import tenantBySubdomainQuery, {tenantBySubdomainKey} from "./queries/tenantBySubdomain"
import tenantQuery, {tenantKey} from "./queries/tenant"

class TenantService extends PBService {
  getTenantBySubdomain = (subdomain: string = getTenantFromPathHelper(), options: QueryOptions = {}): Promise<UnauthedBusiness> => {
    const variables = {subdomain}
    return client.query({...options, query: tenantBySubdomainQuery, variables}).then(({data}) => data[tenantBySubdomainKey])
  }

  get = (businessId: string, options: QueryOptions = {}): Promise<Tenant> => {
    const variables: QueryBusinessArgs = {
      businessId,
      withRootTeam: false,
      withAdmins: false,
      withCreationMeta: false
    }
    return client.query({...options, query: tenantQuery, variables}).then((res) => res.data[tenantKey])
  }

  requestTenant = (tenant: Tenant, options: QueryOptions = {}): Promise<Tenant | UnauthedBusiness> => {
    if (tenant.uuid && !options.unAuth) {
      return this.get(tenant.uuid, options)
    }
    if (tenant.subdomain) {
      return this.getTenantBySubdomain(tenant.subdomain, options)
    }

    return Promise.reject("[RequestTenant]: No tenant identifier given")
  }

  getSubdomainHistory = (tenantId: string, options = {}) => {
    return API.get(`${endpoints.subdomainHistory(tenantId)}`, options).then((res) => res.data)
  }
}

const service = new TenantService({errorHandlers: [tenantErrorHandler]})

export const getTenantBySubdomain = service.getTenantBySubdomain
export const getTenant = service.get
export const requestTenant = service.requestTenant
export const getSubdomainHistory = service.getSubdomainHistory

export default service
